import fonts from './fonts';

const theme = {
  fonts,
};

export default theme;
